export default __webpack_public_path__ + "images/8f1b6e46657fa7aeacb1bc9184daa997-getdata-texto.svg";